import {getBFF} from "@/function/getUrlProdOrPreprod";

import {callApi} from "./_callApi";

export async function postFile(files: FormData): Promise<{fichierId: number}> {
  console.log("Fichier envoyé :", files);
  try {
    if (import.meta.env.VITE_APP_DEV === "true") {
      const reponse = await callApi(
        `${import.meta.env.VITE_APP_API}/api/operation/v1/fichiers`,
        "POST",
        {
          Authorization:
            "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJFUzUxMiIsImtpZCI6IjEifQ.eyJpYXQiOjE3NTQ2NTU4ODguNzU2NzY3LCJuYmYiOjE3NTQ2NTU4ODguNzU2NzY3LCJleHAiOjIwNzAxODg2ODguNzU2NzY3LCJzdWIiOiJjeXJpbEBicmljb3Bybzc5LmZyIiwiY29udHJlbWFycXVlIjoiMTA0MDAwIiwiZXh0cmFuZXQtaWQiOiIxNzgifQ.ATetmxOXN-UhksNfGbGrxg3Tn5eiuJv7iI-_jfd2Jg70cH-dCoCyqc8d6OYTF07mMmNCUhsKZ9wcZIA1u7KEYQWdAOs90-2gUorR2ZKoJ3o7bis1WcTwZT2NmnCIXA_o51SzrCWba-Grf3rbTzhZaf65uatdhJtj1udI-taA--Y_uS_S",
        },
        "same-origin",
        files,
        true,
        false,
      );

      return reponse;
    } else {
      const reponse = await callApi(
        `${getBFF()}/operation/v1/fichiers`,
        "POST",
        {
          "X-Massification-CSRF-Token": csrf,
          "X-CoDeals-CSRF-Token": csrf,
        },
        "same-origin",
        files,
        true,
        false,
      );
      return reponse;
    }
  } catch (error: any) {
    console.log(error.message);
    throw new Error(error?.message);
  }
}

export async function getFile(filesId: number): Promise<File> {
  if (import.meta.env.VITE_APP_DEV === "true") {
    const reponse = await callApi(
      `${import.meta.env.VITE_APP_API}/api/operation/v1/fichiers/${filesId}`,
      "GET",
      {
        Authorization:
          "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJFUzUxMiIsImtpZCI6IjEifQ.eyJpYXQiOjE3NTQ2NTU4ODguNzU2NzY3LCJuYmYiOjE3NTQ2NTU4ODguNzU2NzY3LCJleHAiOjIwNzAxODg2ODguNzU2NzY3LCJzdWIiOiJjeXJpbEBicmljb3Bybzc5LmZyIiwiY29udHJlbWFycXVlIjoiMTA0MDAwIiwiZXh0cmFuZXQtaWQiOiIxNzgifQ.ATetmxOXN-UhksNfGbGrxg3Tn5eiuJv7iI-_jfd2Jg70cH-dCoCyqc8d6OYTF07mMmNCUhsKZ9wcZIA1u7KEYQWdAOs90-2gUorR2ZKoJ3o7bis1WcTwZT2NmnCIXA_o51SzrCWba-Grf3rbTzhZaf65uatdhJtj1udI-taA--Y_uS_S",
      },
      "include",
      null,
      false,
    );
    const fileReturn = await reponse.blob();
    return fileReturn;
  } else {
    const reponse = await callApi(
      `${getBFF()}/operation/v1/fichiers/${filesId}`,
      "GET",
      {
        "Accept-Encoding": "gzip, deflate, br",
        "X-Massification-CSRF-Token": csrf,
        "X-CoDeals-CSRF-Token": csrf,
      },
      "include",
      null,
      false,
    );
    const fileReturn = await reponse.blob();

    return fileReturn;
  }
}
